import { surfaceHref } from "./surface-redirect-response";
const COMPETITOR_DOMAINS: ReadonlySet<string> = new Set([
  "resend.com",
  "postmarkapp.com",
  "sendgrid.com",
  "twilio.com",
  "mailgun.com",
  "agentmail.to",
  "mailtrap.io",
  "brevo.com",
  "apollo.io",
  "smartlead.ai",
  "instantly.ai",
  "lemlist.com",
  "outreach.io",
  "outreach.ai",
  "artisan.co",
  "11x.ai",
]);

export function blogHref(href: string): string | undefined {
  if (!/^(https?:\/\/|\/(?!\/)|#)/i.test(href)) return undefined;
  if (href.startsWith("#")) return href;
  const url = new URL(href, "https://bavimail.com");
  if (url.origin !== "https://bavimail.com") return href;
  if (/^\/faq\/?$/.test(url.pathname)) return "/" + url.search + "#faq";
  if (/^\/pricing\/?$/.test(url.pathname)) return "/pricing" + url.search + url.hash;
  return surfaceHref(href);
}

function isCompetitorHost(host: string): boolean {
  for (const apex of COMPETITOR_DOMAINS) {
    if (host === apex || host.endsWith("." + apex)) return true;
  }
  return false;
}

export function relForUrl(url: string): string | undefined {
  if (!/^https?:\/\//i.test(url)) return undefined;
  const rels = ["noopener", "noreferrer"];
  try {
    const host = new URL(url).hostname.toLowerCase();
    if (isCompetitorHost(host)) rels.push("nofollow");
  } catch {
    // URL parse failure on an http(s)-prefixed string is unusual; default-fix
    // is to add nofollow defensively since we couldn't confirm the host.
    rels.push("nofollow");
  }
  return rels.join(" ");
}
